import { APIRoutes } from "../consts/routes/api-routes";
import API from "./base-service";

export const recordSession = async body => {
  try {
    const result = await API.post(APIRoutes.Session, JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const recordPageView = async body => {
  try {
    const result = await API.post(APIRoutes.PageView, JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updatePageView = async body => {
  try {
    const result = await API.put(`${APIRoutes.PageView}/${body.pageViewId}`, JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getSessions = async () => {
  try {
    const result = await API.get(APIRoutes.Session, { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getPageViews = async () => {
  try {
    const result = await API.get(APIRoutes.Session, { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const getAllAnalytics = async () => {
  try {
    const result = await API.get(APIRoutes.Analytics, { headers: { 'Content-Type': 'application/json' } });
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}